export const PERMANENT_HARD_REFRESH_REQUIRED: string[] = [
    '/lokos-transaction/',
    'clf/final-summary-group',
    'clf/final-summary-member',
];

// Endpoints that match a PERMANENT_HARD_REFRESH_REQUIRED prefix but must NOT
// be force-refreshed unless the user explicitly clicks "Refresh data".
export const PERMANENT_HARD_REFRESH_EXCLUDED: string[] = [
    // 'clf/final-summary-group',
    // 'clf/final-summary-member',
];
